<script setup lang="ts">
import { DialogModal } from '@metapic-apps/shared'

import { BoxComponent, ButtonComponent, FlexComponent, TypographyComponent } from '@/ui-library'

withDefaults(
  defineProps<{
    title: string
    isLoading: boolean
    isSaveDisabled?: boolean
  }>(),
  {
    isSaveDisabled: false,
  },
)

const emits = defineEmits<{
  save: []
}>()

const isOpen = defineModel<boolean>('modelValue', { default: false })
</script>
<template>
  <DialogModal v-model="isOpen" @before-close="() => (isOpen = false)">
    <template #header>
      <TypographyComponent variant="headline-medium">{{ title }}</TypographyComponent>
    </template>

    <template #default>
      <BoxComponent :mt="16" :mb="24">
        <slot />
      </BoxComponent>

      <FlexComponent :gap="8" justify="flex-end">
        <ButtonComponent variant="text" :is-disabled="isLoading" @click="() => (isOpen = false)">Cancel</ButtonComponent>
        <ButtonComponent variant="primary" :is-loading="isLoading" :is-disabled="isSaveDisabled" @click="emits('save')">
          Save
        </ButtonComponent>
      </FlexComponent>
    </template>
  </DialogModal>
</template>
